var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"id":"container","trigger":"click","height":_vm.bannerHeight}},_vm._l((_vm.images),function(image){return _c('el-carousel-item',{key:image.id},[_c('div',{staticClass:"image",style:({
        background: 'url(' + image.path + ') no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover'})})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e846240","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/homepage/components/Banner.vue
// module id = null
// module chunks = 